var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    staticClass: "table-responsive-lg w-100",
    attrs: {
      items: _vm.items,
      "tbody-tr-class": _vm.rowClass,
      fields: _vm.fields,
    },
    scopedSlots: _vm._u([
      {
        key: "cell(mes)",
        fn: function (data) {
          return [_c("span", { domProps: { innerHTML: _vm._s(data.value) } })]
        },
      },
      {
        key: "cell(small_fio)",
        fn: function (data) {
          return [
            _c("div", { domProps: { innerHTML: _vm._s(data.value) } }),
            _vm._v(" "),
            _c("small", [_vm._v(_vm._s(data.item.email))]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }